<template>
  <div v-if="loaded">
    <p class="text-muted small">
      Réparation <strong>{{ pr.repair_reference }}</strong> — ligne
      <strong>{{ pr.reference }}</strong>
    </p>
    <div class="row mt-2">
      <div class="col-md-3 my-2">
        <label>Montant <span class="text-danger">*</span></label>
        <input
          type="number"
          step="0.01"
          min="0"
          v-model="form.amount"
          class="form-control"
        />
      </div>
      <div class="col-md-3 my-2">
        <label>Date</label>
        <input type="date" v-model="form.date" class="form-control" />
      </div>
      <div class="col-md-3 my-2">
        <label>Mode de paiement</label>
        <select v-model="form.paymentMethod" class="form-select">
          <option value="Espèce">Espèce</option>
          <option value="Virement bancaire">Virement bancaire</option>
          <option value="Chèque">Chèque</option>
          <option value="Effet">Effet</option>
        </select>
      </div>
      <div class="col-md-3 my-2">
        <label>Nº chèque</label>
        <input type="text" v-model="form.checkNumber" class="form-control" />
      </div>
      <div class="col-md-3 my-2">
        <label>Nº virement</label>
        <input
          type="text"
          v-model="form.bankTransferNumber"
          class="form-control"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Remarque</label>
        <textarea v-model="form.remark" class="form-control" rows="2" />
      </div>
    </div>
    <div class="row mt-4 justify-content-end">
      <div class="col-auto">
        <button class="btn btn-success" type="button" @click="save">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
  <div v-else class="p-3 text-muted">Chargement…</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loaded: false,
      form: {
        amount: "",
        date: "",
        paymentMethod: "",
        checkNumber: "",
        bankTransferNumber: "",
        remark: "",
      },
    };
  },
  computed: {
    ...mapGetters("paymentRepair", { pr: "getCurrent" }),
  },
  async mounted() {
    const ref = this.$route.params.reference;
    await this.$store.dispatch("paymentRepair/show", ref);
    const p = this.pr;
    if (p && p.reference) {
      this.form.amount = p.amount;
      this.form.date = p.date;
      this.form.paymentMethod =
        (p.payment && p.payment.paymentMethod) || "Espèce";
      this.form.checkNumber = (p.payment && p.payment.checkNumber) || "";
      this.form.bankTransferNumber =
        (p.payment && p.payment.bankTransferNumber) || "";
      this.form.remark = p.remark || "";
    }
    this.loaded = true;
  },
  methods: {
    save() {
      this.$store.dispatch("paymentRepair/update", {
        reference: this.$route.params.reference,
        ...this.form,
      });
    },
  },
};
</script>
